import { Text } from '@acko-tech/building-blocks.ui.typography';
import styled, { css } from 'styled-components';
export const SlideContent = styled.div`
  display: flex;
  align-items: center;
  border-radius: 16px;
  border: 1px solid var(--Border-Disabled-grey50, #F5F5F5);
  margin: 0 auto;
  width: 100%;
  padding: 16px;
  margi-right: 50px;
  position: relative;
  z-index: 1;
  @media (min-width: 768px) {
    margin-bottom: -20px;
  }
`;

export const SlidesImageWrapper = styled.div`
  flex-shrink: 0;
  margin-right: 12px;
  width: 56px;
`;

export const CarImage = styled.img`
  width: 56px;
  height: 56px;
  height: auto;
  display: block;
`;

export const TextContainer = styled.div`
  flex-grow: 1;
  text-align: left;
`;

export const ClaimsText = styled.p`
  font-size: 14px;
  font-weight: 700;
  color: #383151;
  margin: 0;
  line-height: 1.3;

  & > strong {
      font-size: 36px; 
      color: #5E5779; 
  }
`;

export const DealerText = styled.p`
  font-size: 14px;
  font-weight: 400;
  color: #5E5779;
  margin-top: 5px;
  line-height: 1.4;
`;

export const ShowVideoNudge = styled.div`
  display: none;
  width: 402px;
  padding: 24px 8px 8px 8px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 0 0 16px 16px;
  background: rgba(239, 233, 251, 0.48);
  backdrop-filter: blur(2px);
  position: relative;
  z-index: 0;
  cursor: pointer;
  @media (min-width: 768px) {
    display: flex;
  }

`;

export const WatchVideoText = styled(Text)`
  color: var(--Purple-P400, #5920C5);
  font-family: "Euclid Circular B";
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
`;